<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div style="width: 100%;height: 32px;"></div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
        <el-form-item label="充值开关：" prop="rechargeStatus">
          <el-radio-group v-model="ruleForm.rechargeStatus">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="充值说明：" prop="rechargeDesc">
          <editor :value="ruleForm.rechargeDesc" :height="350" v-model="ruleForm.rechargeDesc"></editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// import { saveOrUpdateRechargeConfig, fetchMoneyRechargeConfigDetail } from '@/api/balance'
import { saveOrUpdateShopConfig, fetchShopConfigDetail } from '@/api/shop'
import Editor from '@/components/Editor.vue'
export default {
  name: 'RechargeConfig',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      ruleForm: {
        rechargeStatus:'',
        rechargeDesc:''
      },
      rules: {
        rechargeStatus: [
          { required: true, message: '请选择充值开关', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    var that = this;
    fetchShopConfigDetail({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.ruleForm.rechargeStatus = data.rechargeStatus;
          that.ruleForm.rechargeDesc = data.rechargeDesc;
        }
    })
  },
  methods: {
    // 保存操作
    saveBtn () {
      let that = this
      let ruleForm = that.ruleForm
      that.fullscreenLoading = true
      saveOrUpdateShopConfig({rechargeStatus:ruleForm.rechargeStatus,rechargeDesc:ruleForm.rechargeDesc}).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/balance/RechargeConfig.vue